import { EOrderAsLastTimeState } from '@model';

import { EcommerceSectionNamespace } from '../model';

export const mapOaltStateToEcommerce = (
  oaltState: EOrderAsLastTimeState,
): EcommerceSectionNamespace.EEcommerceOaltStepName => {
  switch (oaltState) {
    case EOrderAsLastTimeState.INFO_PAGE:
      return EcommerceSectionNamespace.EEcommerceOaltStepName.FIRST_STEP;
    case EOrderAsLastTimeState.ACTION_PAGE:
      return EcommerceSectionNamespace.EEcommerceOaltStepName.SECOND_STEP;
    case EOrderAsLastTimeState.ADDITIONAL_ACTION_PAGE:
      return EcommerceSectionNamespace.EEcommerceOaltStepName.THIRD_STEP;
    case EOrderAsLastTimeState.ERROR:
      return EcommerceSectionNamespace.EEcommerceOaltStepName.ERROR_STEP;
    default:
      return EcommerceSectionNamespace.EEcommerceOaltStepName.FIRST_STEP;
  }
};
